export enum StandardNumberType {
  Isbn = "Isbn",
  Issn = "Issn",
  Upc = "Upc",
  Pubnum = "Pubnum",
  Asin = "Asin",
}

export interface StandardNumber {
  id: number;
  type: StandardNumberType;
  data: string;
}
